'use client';

import './style.sass';

import React from 'react';

import { useMedia } from 'react-use';

const BannerCaseRule = ({ video, img }) => {
    const isMobile = useMedia('(max-width: 750px)');
    return (
        <div className="banner-case__wrapper">
            {!video || isMobile ? (
                <img src={img} alt={img} className="banner-case__img" />
            ) : (
                <video
                    muted={true}
                    playsInline={true}
                    autoPlay={true}
                    loop={true}
                    className="banner-case__video"
                >
                    <source src={video} type="video/mp4" />
                    <source src={video} type="video/webm" />
                </video>
            )}
        </div>
    );
};
export default BannerCaseRule;
